export default __webpack_public_path__ + "static/media/system-uicons_translate.60c3ded8.svg";